module.exports = __webpack_public_path__ + "9102ba65992c398772ac7a6cfb23a835.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-15.png
// module id = 1561
// module chunks = 0